import { useState, useEffect } from 'react';
import ModalTolltip from '../Modal/Tooltip';
import { RiGroupLine, RiInformationLine } from '@remixicon/react';
import { CurrencyFormatterNonDecimal } from '../../helpers/utils';
import { Guaranteed } from '../Icons/Guaranteed';

interface Props {
	infoIcon: 'warning' | 'success';
	title?: string;
	tournament: any;
	children: JSX.Element;
}

export default function TooltipTournamentInfo({
	infoIcon,
	title = '',
	tournament,
	children,
}: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const handleClick = () => {
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		const handleClickOutside = () => setIsOpen(false);

		document.addEventListener('click', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		if (!isOpen) return;
		const timer = setTimeout(() => {
			setIsOpen(false);
		}, 8000);

		return () => {
			clearTimeout(timer);
		};
	}, [isOpen]);

	return (
		<>
			<button
				onClick={(e: any) => {
					e.stopPropagation();
					handleClick();
				}}
				className="flex flex-row items-center justify-end mr-1 gap-1"
			>
				{children}
			</button>

			<ModalTolltip
				id={'modalTooltip'}
				open={isOpen}
				onClose={handleClick}
				infoIcon={infoIcon}
			>
				{title && (
					<h2 className="text-black text-lg font-semibold font-bahnschrift leading-7">
						{title}
					</h2>
				)}

				<div className="flex flex-col gap-2">
					<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
						<span>
							<RiGroupLine
								color="#636363"
								size={16}
								className="inline-block align-middle mr-1"
							/>
							<span className="inline-block align-middle mr-1">
								{tournament.qtdRegistration}
							</span>
						</span>
						- Atualmente, o torneio conta com{' '}
						{tournament.qtdRegistration} inscrições confirmadas.
					</p>

					{Number(tournament.entryMinQtd) === 0 ? (
						<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
							<span className="text-primary">
								<Guaranteed
									color="#979797"
									className="w-[18px] h-[18px] inline-block align-middle mr-1"
								/>
							</span>
							- A realização do torneio é GARANTIDA, sem depender
							do número de inscrições.
						</p>
					) : (
						<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
							{tournament.entryMinQtd} - Para que o torneio
							aconteça, é preciso que no mínimo{' '}
							{tournament.entryMinQtd} inscrições sejam
							realizadas.
						</p>
					)}

					{Number(tournament.entryMaxQtd) !== 0 && (
						<p className="text-[#535861] text-sm font-light font-bahnschrift leading-tight">
							{Number(tournament.entryMaxQtd)} - Este torneio tem
							um limite máximo de{' '}
							{CurrencyFormatterNonDecimal(
								Number(tournament.entryMaxQtd)
							)}{' '}
							inscrições.
						</p>
					)}
				</div>
			</ModalTolltip>
		</>
	);
}
